module.exports = __webpack_public_path__ + "img/sunteclogo.585aec81.jpg";